import { createSlice } from "@reduxjs/toolkit";
import { fetchDoctorWalletReducer } from "../../reducer/doctorWallet/fetchDoctorWalletReducer";

import i18n from "../../i18n";
const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const doctorWalletSlice = createSlice({
  name: "doctorWallet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorWalletReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDoctorWalletReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload || {};
        console.log("✅ Doctor Wallet Loaded:", action.payload);
      })
      .addCase(fetchDoctorWalletReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadDoctorWalletDetails");
      });
  },
});

export default doctorWalletSlice.reducer;
